import { invitationStatusValues, strings } from "@/constants";
import { ButtonTypeEnum } from "@/enums";
import type { InvitationStatusType } from "@/types";

export type StatusFilterType = InvitationStatusType | "all";

const statusFilters: { label: string, value: StatusFilterType }[] = [
    {
        label: strings.admin.filterAll,
        value: "all",
    },
    {
        label: strings.admin.filterPending,
        value: invitationStatusValues.pending,
    },
    {
        label: strings.admin.filterAccepted,
        value: invitationStatusValues.accepted,
    },
    {
        label: strings.admin.filterExpired,
        value: invitationStatusValues.expired,
    },
    {
        label: strings.admin.filterCancelled,
        value: invitationStatusValues.cancelled,
    },
];

export const InvitationsFilter = ({
    onChange,
    value,
}: {
    onChange: (value: StatusFilterType) => void,
    value: StatusFilterType,
}) => (
    <div
        className="
            flex
            flex-wrap
            gap-1
            overflow-x-auto
            rounded-full
            border
            border-gray-200
            bg-gray-50
            p-1
        "
    >
        {statusFilters.map(({
            label,
            value: filterValue,
        }) => (
            <button
                key={filterValue}
                type={ButtonTypeEnum.BUTTON}
                className={`
                    shrink-0
                    rounded-full
                    px-4
                    py-2
                    text-sm
                    font-medium
                    whitespace-nowrap
                    transition-colors
                    ${value === filterValue ? "bg-primary text-white" : "text-text-secondary hover:text-primary"}
                `}
                onClick={() => onChange(filterValue)}
            >
                {label}
            </button>
        ))}
    </div>
);
